import { z } from "zod";
import { memberPermissionsSchema } from "./member-permission.js";
import { memberRoleSchema } from "./member-role.js";
export const inviteMemberSchema = z
    .object({
    email: z.email({ message: "Email invalide" }).toLowerCase().trim(),
    role: memberRoleSchema,
    permissions: memberPermissionsSchema.optional(),
})
    .strict();
export const updateMemberSchema = z
    .object({
    role: memberRoleSchema.optional(),
    permissions: memberPermissionsSchema.optional(),
})
    .strict();
